<template>
  <div class="wrap">
    <div class="agenda">
      <div class="agendaTitle">大会日程</div>
      <div class="agendaEn">CONFERENCE AGENDA</div>
      <div class="agendaBox">
        <a-tabs class="dateTab" v-model:activeKey="activeKey" centered>
          <a-tab-pane v-for="(item, index) in arr" :key="index">
            <template #tab>
              <span class="dateTabTitle">
                <img
                  v-if="index === activeKey"
                  src="https://p5.ssl.qhimg.com/t110b9a93019153ac081a9b1817.png"
                  alt=""
                  class="agendaBoxHead dateTabTitleImg"
                />
                <span class="dateTabTitleText">{{ item.date }}</span>
              </span>
            </template>
            <div class="agendaInfo">
              <div class="agendaInfoTitle">
                <span class="agendaInfoTitleText">{{ item.title }}</span>
                <span class="agendaInfoTitleDate">{{ item.time }}</span>
                <a-tabs class="contentTab" v-model:activeKey="tabArr[index]">
                  <a-tab-pane v-for="(child, index) in item.info" :key="index" :tab="child.title">
                    <div class="info">
                      <div v-for="(element, index) in child.children" class="infoBox">
                        <div v-if="index + 1 !== child.children.length" class="infoBoxLine"></div>
                        <img
                          src="https://p0.ssl.qhimg.com/t11b673bcd63f2769f075005029.png"
                          alt=""
                          class="infoBoxImg"
                        />
                        <div class="infoBoxTime">{{ element.time }}</div>
                        <div class="infoBoxArr">
                          <div v-for="(detail, index) in element.detail" class="infoBoxArrItem">
                            <div class="infoBoxArrItemTitle">{{ detail.title }}</div>
                            <div class="infoBoxArrItemPlace">
                              <img
                                src="https://s0.ssl.qhres2.com/static/bc764249255f4586.svg"
                                alt=""
                                class="infoBoxArrItemPlaceImg"
                              />
                              {{ detail.place }}
                            </div>
                            <div v-if="detail.path" @click="jumpLink(detail.path)" class="infoBoxArrItemDetail">
                              <img
                                src="https://s5.ssl.qhres2.com/static/21dd7744708df032.svg"
                                alt=""
                                class="infoBoxArrItemDetailImg"
                              />

                              查看详情
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </a-tab-pane>
                </a-tabs>
              </div>
            </div>
          </a-tab-pane>
        </a-tabs>
        <img
          src="https://p2.ssl.qhimg.com/t11b673bcd65afa52f10d0a019f.png"
          alt=""
          class="agendaBoxImg"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
const tabArr = ref([0, 0, 0])
const activeKey = ref(0)

const props = defineProps(['arr'])
const arr = props.arr || {}

const jumpLink = (url) => {
  if(url) {
    window.open(url, '_blank');
  }
}
// const arr = ref([
//   {
//     date: '07/31',
//     title: '数字安全日',
//     time: '09:00~18:00',
//     info: [
//       {
//         title: '高峰论坛',
//         children: [
//           {
//             time: '14:00~15:00',
//             detail: [
//               {
//                 title: 'AI+关键信息基础设施保护',
//                 place: '北京 · 国家会议中心311B会议室',
//                 path: ''
//               },
//               {
//                 title: '数据安全与隐私保护',
//                 place: '北京 · 国家会议中心311B会议室',
//                 path: ''
//               }
//             ]
//           },
//           {
//             time: '15:00-18:00',
//             detail: [
//               {
//                 title: 'AI+高级可持续威胁防御',
//                 place: '北京 · 国家会议中心311B会议室',
//                 path: ''
//               },
//               {
//                 title: '大模型安全挑战与治理',
//                 place: '北京 · 国家会议中心311B会议室',
//                 path: ''
//               },
//               {
//                 title: '网络犯罪打击与质量',
//                 place: '北京 · 国家会议中心311B会议室',
//                 path: ''
//               }
//             ]
//           }
//         ]
//       },
//       {
//         title: '主题论坛'
//       }
//     ]
//   },
//   {
//     date: '08/01',
//     title: 'ai人工智能日',
//     time: '09:00~18:00',
//     info: [
//       {
//         title: '高峰论坛',
//         children: [
//           {
//             time: '14:00~15:00',
//             detail: [
//               {
//                 title: 'AI+关键信息基础设施保护',
//                 place: '北京 · 国家会议中心311B会议室',
//                 path: ''
//               },
//               {
//                 title: '数据安全与隐私保护',
//                 place: '北京 · 国家会议中心311B会议室',
//                 path: ''
//               }
//             ]
//           },
//           {
//             time: '15:00-18:00',
//             detail: [
//               {
//                 title: 'AI+高级可持续威胁防御',
//                 place: '北京 · 国家会议中心311B会议室',
//                 path: ''
//               },
//               {
//                 title: '大模型安全挑战与治理',
//                 place: '北京 · 国家会议中心311B会议室',
//                 path: ''
//               },
//               {
//                 title: '网络犯罪打击与质量',
//                 place: '北京 · 国家会议中心311B会议室',
//                 path: ''
//               }
//             ]
//           }
//         ]
//       },
//       {
//         title: '主题论坛'
//       }
//     ]
//   },
//   {
//     date: '08/02',
//     title: 'ai人工智能日',
//     time: '09:00~18:00',
//     info: [
//       {
//         title: '高峰论坛',
//         children: [
//           {
//             time: '14:00~15:00',
//             detail: [
//               {
//                 title: 'AI+关键信息基础设施保护',
//                 place: '北京 · 国家会议中心311B会议室',
//                 path: ''
//               },
//               {
//                 title: '数据安全与隐私保护',
//                 place: '北京 · 国家会议中心311B会议室',
//                 path: ''
//               }
//             ]
//           },
//           {
//             time: '15:00-18:00',
//             detail: [
//               {
//                 title: 'AI+高级可持续威胁防御',
//                 place: '北京 · 国家会议中心311B会议室',
//                 path: ''
//               },
//               {
//                 title: '大模型安全挑战与治理',
//                 place: '北京 · 国家会议中心311B会议室',
//                 path: ''
//               },
//               {
//                 title: '网络犯罪打击与质量',
//                 place: '北京 · 国家会议中心311B会议室',
//                 path: ''
//               }
//             ]
//           }
//         ]
//       },
//       {
//         title: '主题论坛'
//       }
//     ]
//   }
// ])
</script>

<style lang="scss" scoped>
.wrap {
  opacity: 1;
  background-color: #f3f3f3;
  padding:73px 0 87px;
  // background-color: pink;
}
.agenda {
  min-width: 1230px;
  width: 90%;
  margin: 0 auto;
  &Title {
    font-family: Source Han Sans;
    font-size: 48px;
    font-weight: 700;
    line-height: 48px;
    letter-spacing: 0px;
    font-variation-settings: 'opsz' auto;
    /* Gray 中性/gray-9 */
    color: #242933;
  }
  &En {
    margin-top: 16px;
    margin-bottom: 64px;
    font-family: Source Han Sans;
    font-size: 24px;
    font-weight: normal;
    line-height: 20px;
    letter-spacing: 0px;
    /* Gray 中性/gray-7 */
    color: #8a9099;
    display: inline-block;
  }
  &Info {
    z-index: 99;
    border-radius: 32px;
    opacity: 1;
    background: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(120px);
    padding: 80px 8% 92px 8%;
    margin-top: 40px;
    &Title {
      &Text {
        font-family: Source Han Sans;
        font-size: 40px;
        font-weight: 500;
        line-height: 48px;
        letter-spacing: 0px;
        font-variation-settings: 'opsz' auto;
        /* Gray 中性/gray-9 */
        color: #242933;
        margin-right: 24px;
      }
      &Date {
        font-family: Source Han Sans;
        font-size: 24px;
        font-weight: normal;
        line-height: 32px;
        letter-spacing: 0px;
        font-variation-settings: 'opsz' auto;
        /* Gray 中性/gray-7 */
        color: #8a9099;
      }
    }
  }
  &Box {
    position: relative;
    &Head {
      width: 72px;
    }
    &Img {
      position: absolute;
      top: 0;
      left: -500px;
      display: block;
      width: 564px;
      height: 564px;
    }
  }
}

.info {
  margin-top: 25px;
  padding-left: 41px;

  &Box {
    display: flex;
    &Line {
      position: absolute;
      top: 26px;
      left: -36px;
      width: 1px;
      height: 95%;
      background: #e8eaed;
    }
    &Img {
      position: absolute;
      top: 11px;
      left: -40px;
      width: 9px;
      height: 9px;
    }
    &Time {
      font-family: Source Han Sans;
      font-size: 20px;
      font-weight: normal;
      letter-spacing: 0px;
      font-variation-settings: 'opsz' auto;
      color: #8a9099;
      margin-right: 32px;
      // width: 43px;
    }
    &Arr {
      width: 92%;
      &Item {
        display: flex;
        align-items: center;
        margin-bottom: 48px;
        &Title {
          font-family: Source Han Sans;
          font-size: 20px;
          font-weight: 500;
          line-height: 32px;
          letter-spacing: 0.02em;
          font-variation-settings: 'opsz' auto;
          color: #3d3d3d;
          // width: 620px;
          width: 54%;
        }
        &Place {
          margin: 0 40px;
          // width: 370px;
          width: 25%;
          font-family: Source Han Sans;
          font-size: 16px;
          font-weight: normal;
          line-height: 24px;
          letter-spacing: 0.02em;
          font-variation-settings: 'opsz' auto;
          color: #3d3d3d;
          &Img {
            margin-right: 16px;
          }
        }
        &Detail {
          width: 107px;
          &Img {
            margin-right: 12px;
          }
          cursor: pointer;
          font-family: Source Han Sans;
          font-size: 16px;
          font-weight: normal;
          line-height: 24px;
          letter-spacing: 0.02em;
          font-variation-settings: 'opsz' auto;
          /* Gray 中性/gray-7 */
          color: #8a9099;
        }
      }
    }
  }
}

.ant-tabs {
  margin-top: 47px;
}

.dateTab :deep(.ant-tabs-tab) {
  padding: 12px 0 22px;
  margin-right: 56px;
}

.dateTab :deep(.ant-tabs-tab .ant-tabs-tab-btn .dateTabTitleText) {
  font-family: Source Han Sans;
  font-size: 32px;
  font-weight: bold;
  line-height: 32px;
  letter-spacing: 0px;
  color: #8a9099;
}
.dateTab :deep(.ant-tabs-ink-bar) {
  background-color: #242933;
}

.dateTab :deep(.ant-tabs-tab-active .ant-tabs-tab-btn .dateTabTitleText) {
  font-family: Source Han Sans;
  font-size: 32px;
  font-weight: bold;
  line-height: 32px;
  letter-spacing: 0px;
  color: #242933;
  margin-left: 16px;
}

.dateTab :deep(.ant-tabs-tab-active .ant-tabs-tab-btn .dateTabTitle) {
  display: flex;
  align-items: center;
}

.contentTab :deep(.ant-tabs-tab .ant-tabs-tab-btn) {
  font-family: Source Han Sans;
  font-size: 32px;
  font-weight: bold;
  line-height: 48px;
  letter-spacing: 0px;
  color: #525966;
}

.contentTab :deep(.ant-tabs-tab-active .ant-tabs-tab-btn) {
  font-family: Source Han Sans;
  font-size: 32px;
  font-weight: bold;
  line-height: 48px;
  letter-spacing: 0px;
  color: #497ced;
}

.contentTab :deep(.ant-tabs-ink-bar) {
  background-color: #497ced;
}

.contentTab :deep(.ant-tabs-tab) {
  padding: 12px 0;
  margin-right: 36px;
}
</style>
